import cogoToast from 'cogo-toast';
import api from './apiURL';
const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');


// Get Profile Data
export const getUserInfo = createAsyncThunk(
    'profile/getUserInfo',
    async (_, thunkAPI) => {
      
      const { rejectWithValue } = thunkAPI;

      try {
        const res = await fetch( api + '/api/v1/user/profile', {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const data = await res.json();
        console.log(data);
        return data;
        
      } catch (error) {
        console.log(error);
        return rejectWithValue(error.message);
      }
    }
  );

// Get all countries
export const getCountries = createAsyncThunk(
  'profile/getCountries',
  async (_, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/location/countries', {
        method: 'GET',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

// Get cities by ID
export const getCitiesById = createAsyncThunk(
  'profile/getCitiesById',
  async (countryId, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/location/cities/'+countryId+ '', {
        method: 'GET',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

// Get areas by ID
export const getAreasById = createAsyncThunk(
  'profile/getAreasById',
  async (cityId, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/location/areas/'+cityId+ '', {
        method: 'GET',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

// Get districts by ID
export const getDistrictsById = createAsyncThunk(
  'profile/getDistrictsById',
  async (areaId, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/location/districts/'+areaId+ '', {
        method: 'GET',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

// Add Address Request
export const addNewAdress = createAsyncThunk(
  'profile/addNewAdress',
  async (addressData, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/user/add-address', {
        method: 'POST',
        body: JSON.stringify(addressData),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      console.log(data.success);
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const editProfileInfo = createAsyncThunk(
  'profile/editProfileInfo',
  async (userInfo, thunkAPI) => {
    console.log(userInfo);  
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/user/profile', {
        method: 'PATCH',
        body: JSON.stringify(userInfo),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

// Delete Address Request
export const deleteAddressById = createAsyncThunk(
  'profile/deleteAdress',
  async (addressId, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/user/delete-address/'+addressId+ '', {
        method: 'DELETE',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const changePassword = createAsyncThunk(
  'profile/changePassword',
  async (passwordDetails, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    console.log(passwordDetails);
    if(passwordDetails.newPasswordConfirmation!==passwordDetails.newPassword){
      cogoToast.error("Passwords Don't Match", {position: "bottom-left"});
      return ; 
    }

    try {
      const res = await fetch(api + '/api/v1/user/update-password', {
        method: 'POST',
        body: JSON.stringify(passwordDetails),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      console.log(data);
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);


const ProfileSlice = createSlice({
    name: "profile",
    initialState: {
      loading: false,
      error: null,
      countries: [],
      cities: [],
      areas: [],
      districts: [],
      singleAddress:{},
      userInfo: {},
      password:[]
    },
    reducers: {},
    extraReducers: {

      [editProfileInfo.pending]:(state,action)=>{
        state.loading = true;
        state.error = null;
      },

      [editProfileInfo.fulfilled]:(state,action)=>{
        if(action.payload.error === false ){
          cogoToast.error("Faild To Update Profile Info", {position: "bottom-left"});
          return ;
        }
        state.loading = false;
        state.error = null;
        cogoToast.success("Profile Info Updated Successfully ", {position: "bottom-left"});

      },

      [editProfileInfo.rejected]:(state,action)=>{
        state.loading = false;
        state.error = action.payload;
        cogoToast.error("Faild To Update Profile Info", {position: "bottom-left"});

      },

      // Get User Info
      [getUserInfo.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },
      [getUserInfo.fulfilled]: (state, action) => {
        state.loading = false;


        if (action.payload.success === false){
          
          state.userInfo = action.payload;
          // cogoToast.error("Countries Failed in Fullfilled" , {position: "bottom-left"});
        }
        else{
          state.userInfo = action.payload;
          //  cogoToast.success("Countries Success", {position: "bottom-left"});
        }
          
      },
      [getUserInfo.rejected]: (state, action) => {
          state.error = action.payload;
          state.loading = false;
          // cogoToast.error("Countries Failed", {position: "bottom-left"});
      },

      // Get Countries
      [getCountries.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },
      [getCountries.fulfilled]: (state, action) => {
        state.loading = false;

        if (action.payload.success === false){
          // cogoToast.error("Countries Failed in Fullfilled" , {position: "bottom-left"});
        }else{
          state.countries = action.payload;
          // cogoToast.success("Countries Success", {position: "bottom-left"});
        }
          
      },
      [getCountries.rejected]: (state, action) => {
          state.error = action.payload;
          state.loading = false;

          // cogoToast.error("Countries Failed", {position: "bottom-left"});
      },

      // Get Cities By ID
      [getCitiesById.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },
      [getCitiesById.fulfilled]: (state, action) => {
        state.loading = false;

        if (action.payload.success === false){
          
          // cogoToast.error("Cities Failed in Fullfilled" , {position: "bottom-left"});
        }else{
          state.cities = action.payload;
          
          // cogoToast.success("Cities Success", {position: "bottom-left"});
        }
          
      },
      [getCitiesById.rejected]: (state, action) => {
        state.loading = false;
          state.error = action.payload;
          // cogoToast.error("Cities Failed", {position: "bottom-left"});
      },

      // Get Areas By ID
      [getAreasById.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },
      [getAreasById.fulfilled]: (state, action) => {
        state.loading = false;

        if (action.payload.success === false){
          
          // cogoToast.error("Areas Failed in Fullfilled" , {position: "bottom-left"});
        }else{
          state.areas = action.payload;
          
          // cogoToast.success("Areas Success", {position: "bottom-left"});
        }
          
      },
      [getAreasById.rejected]: (state, action) => {
          state.error = action.payload;
          state.loading = false;

          // cogoToast.error("Areas Failed", {position: "bottom-left"});
      },

      // Get Districts By ID
      [getDistrictsById.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },
      [getDistrictsById.fulfilled]: (state, action) => {
        state.loading = false;


        if (action.payload.success === false){
          
          // cogoToast.error("Districts Failed in Fullfilled" , {position: "bottom-left"});
        }else{
          state.districts = action.payload;
          
          // cogoToast.success("Districts Success", {position: "bottom-left"});
        }
          
      },
      [getDistrictsById.rejected]: (state, action) => {
          state.error = action.payload;
          state.loading = false;
          // cogoToast.error("Districts Failed", {position: "bottom-left"});
      },


      // Add New Address
      [addNewAdress.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },
      [addNewAdress.fulfilled]: (state, action) => {
        state.loading = false;

        if (action.payload.success === false){
          
          cogoToast.error("Adding New Address Failed" , {position: "bottom-left"});
        }else{
          state.userInfo = action.payload;
          cogoToast.success("New Address Added Successfully", {position: "bottom-left"});
        }
          
      },
      [addNewAdress.rejected]: (state, action) => {
          state.error = action.payload;
          cogoToast.error("Adding New Address Failed", {position: "bottom-left"});
          state.loading = false;
      },


      // Delete Address
      [deleteAddressById.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },
      [deleteAddressById.fulfilled]: (state, action) => {
        state.loading = false;

        if (action.payload.success === false){
          
          cogoToast.error("Address Delete Failed" , {position: "bottom-left"});
        }else{
          state.userInfo = action.payload;
          
          cogoToast.success(" Address Deleted Successfully", {position: "bottom-left"});
        }
          
      },
      [deleteAddressById.rejected]: (state, action) => {
          state.error = action.payload;
          cogoToast.error("Address Delet Failed", {position: "bottom-left"});
          state.loading = false;
          state.error = action.payload;
      },

      [changePassword.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },
      [changePassword.fulfilled]: (state, action) => {
        state.loading = false;
        state.error = null;
        if(action.payload.success===false || action.payload.errors){
          cogoToast.error("Failed To Change Password", {position: "bottom-left"});
          return ; 
        }
        state.passwordChanged = true;
        cogoToast.success("Password Changed Sucessfully", {position: "bottom-left"});
      },
      [changePassword.rejected]: (state, action) => {
        state.loading = false;
        state.error = action.payload;
        cogoToast.error("Failed To Change Password", {position: "bottom-left"});

      },
    },
});

//export const { addToCompare, deleteFromCompare } = authSlice.actions;
export default ProfileSlice.reducer;


